import Link from "next/link";

import { Fragment, useState, useEffect } from "react";
const Menu = ({ singleMenu, menuData }) => {
  console.log(menuData);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Update the state to reflect the client's screen width
    setIsMobile(window.innerWidth <= 768);
  }, [isMobile]);

  return (
    <Fragment>
      {singleMenu ? (
        <SingleMenu />
      ) : (
        !isMobile ? 
          <DaskTopMenu menuData={menuData} />
        :
        <MobileMenu menuData={menuData} />
      )}
    </Fragment>
  );
};
export default Menu;

const DaskTopMenu = ({menuData}) => {


  return (
    <ul className="navigation d-none d-lg-flex desktop-menu">
      <li>
        <Link href="/">Home</Link>
        
      </li>
            <li className="dropdown">
        <Link href="/" style={{'pointerEvents': 'none' }}  >Services</Link>
        <ul>
        {/* menu_name_number, */}
          {menuData?.map((item, index) => (
    <li key={index}>
    <Link  href={`/solutions/${item?.slug?.current}`}>
    {item.menu_name}
    </Link>
  </li>
          ))}

        </ul>
        <div className="dropdown-btn">
          <span className="far fa-plus" />
        </div>
      </li>      <li className="dropdown">
      <Link href="/projects">Projects</Link>      
      </li>
      <li>
        <Link legacyBehavior href="/about">
          About Us
        </Link>
      </li>
      
      <li className="dropdown">
        {/* <a href="#">pages</a> */}
        <Link legacyBehavior href="/contact">
              Contact us
            </Link>
        {/* <ul>
          <li>
            <Link legacyBehavior href="faqs">
              faqs
            </Link>
          </li>
          <li className="dropdown">
            <a href="#">Products</a>
            <ul>
              <li>
                <Link legacyBehavior href="shop">
                  our Products
                </Link>
              </li>
              <li>
                <Link legacyBehavior href="product-details">
                  Product Details
                </Link>
              </li>
            </ul>
            <div className="dropdown-btn">
              <span className="far fa-plus" />
            </div>
          </li>
          <li className="dropdown">
            <a href="#">Team</a>
            <ul>
              <li>
                <Link legacyBehavior href="team">
                  Team Members
                </Link>
              </li>
              <li>
                <Link legacyBehavior href="team-details">
                  Team Details
                </Link>
              </li>
            </ul>
            <div className="dropdown-btn">
              <span className="far fa-plus" />
            </div>
          </li>
          <li>
            <Link legacyBehavior href="contact">
              Contact us
            </Link>
          </li>
          <li>
            <Link legacyBehavior href="pricing">
              Pricing Plan
            </Link>
          </li>
          <li>
            <Link legacyBehavior href="404">
              404 error
            </Link>
          </li>
        </ul>


        <div className="dropdown-btn">
          <span className="far fa-plus" />
        </div> */}
      </li>


      <li className="dropdown">
      <Link legacyBehavior href="/blog">Blogs  </Link>
      </li>
    </ul>
  );
};

const MobileMenu = ({menuData}) => {
  const [activeMenu, setActiveMenu] = useState("");
  const activeMenuSet = (value) =>
      setActiveMenu(activeMenu === value ? "" : value),
    activeLi = (value) =>
      value === activeMenu ? { display: "block" } : { display: "none" };
 
  return (
    <ul className="navigation d-block d-lg-none mobile-menu">
      <li className="dropdown">
        <Link href="/">Home</Link>
    
  
      </li>
      <li>
        <Link  href="/about">
          About Us
        </Link>
      </li>
      <li className="dropdown">
        <Link href="/contact">Contact</Link>
       
      </li>
      <li className="dropdown">
        <Link href="#">Services</Link>
        <ul style={activeLi("Services")}>
        {menuData?.map((item, index) => ( 

<li key={index}>
<Link legacyBehavior href={`solutions/${item?.slug?.current}`}>
 {item.title}
</Link>
</li>
           )   )
}
        
         
        </ul>
        <div className="dropdown-btn" onClick={() => activeMenuSet("Services")}>
          <span className="far fa-plus" />
        </div>
      </li>
      <li className="dropdown">
        <Link href="/projects">Projects</Link>
       
      </li>
      <li className="dropdown">
        <Link href="/blogs">insights</Link>
     
      </li>
    </ul>
  );
};

const SingleMenu = () => {
  return (
    <ul className="navigation onepage clearfix">
      <li>
        <Link href="#home">Home</Link>
      </li>
      <li>
        <Link href="#about">about</Link>
      </li>
      <li>
        <Link href="#services">services</Link>
      </li>
      <li>
        <Link href="#projects">project</Link>
      </li>
      <li>
        <Link href="#pricing">pricing</Link>
      </li>
      <li>
        <Link href="#news">news</Link>
      </li>
    </ul>
  );
};
